var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_3805)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2261_3805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2779 14.7935C15.2779 15.0587 15.1726 15.313 14.985 15.5006C14.7975 15.6881 14.5431 15.7935 14.2779 15.7935H2.30859C2.04338 15.7935 1.78902 15.6881 1.60149 15.5006C1.41395 15.313 1.30859 15.0587 1.30859 14.7935V1.79346C1.30859 1.52824 1.41395 1.27389 1.60149 1.08635C1.78902 0.898814 2.04338 0.793457 2.30859 0.793457H12.3086C12.5694 0.793483 12.8199 0.895394 13.0066 1.07746L14.9766 2.99946C15.072 3.09267 15.1479 3.20404 15.1996 3.327C15.2514 3.44997 15.278 3.58205 15.2779 3.71546V14.7935Z",
    stroke: "#BEBBB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30859 5.29346C4.30859 5.69128 4.46663 6.07281 4.74793 6.35412C5.02924 6.63542 5.41077 6.79346 5.80859 6.79346C6.20642 6.79346 6.58795 6.63542 6.86925 6.35412C7.15056 6.07281 7.30859 5.69128 7.30859 5.29346C7.30859 4.89563 7.15056 4.5141 6.86925 4.2328C6.58795 3.95149 6.20642 3.79346 5.80859 3.79346C5.41077 3.79346 5.02924 3.95149 4.74793 4.2328C4.46663 4.5141 4.30859 4.89563 4.30859 5.29346V5.29346Z",
    stroke: "#BEBBB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8353 12.4269L10.2186 8.50159C10.1578 8.41013 10.0756 8.33491 9.97909 8.28247C9.8826 8.23004 9.77476 8.20198 9.66494 8.20073C9.55513 8.19948 9.44668 8.22508 9.34902 8.27531C9.25136 8.32554 9.16745 8.39887 9.10459 8.48892L7.31059 11.0523L6.19859 10.1603C6.1256 10.1018 6.04123 10.0591 5.95086 10.035C5.86048 10.0109 5.76607 10.0058 5.67364 10.0202C5.58121 10.0346 5.49278 10.068 5.41398 10.1184C5.33518 10.1688 5.26773 10.235 5.21593 10.3129L3.80859 12.4269",
    stroke: "#BEBBB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_3805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2261_3805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.292969 0.293457)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/Image_icon.9e2682b8.svg";
export { ForwardRef as ReactComponent };